import React from "react";
import { MRT_ColumnDef } from "material-react-table";
import { Box } from "@mui/material";
import { getFormattedDate } from "utils";

export const emissionFactorDetailColumn: MRT_ColumnDef<any>[] = [
  {
    accessorKey: "providerName",
    header: "Utility Provider",
  },
  {
    accessorKey: "utilityType",
    header: "Utility Type",
  },
  {
    accessorKey: "efValue",
    header: "EF Value",
  },
  {
    accessorKey: "efUnit",
    header: "EF Unit",
  },
  {
    accessorKey: "renewableEnergy",
    header: "RE Percentage",
  },
  {
    accessorKey: "startDate",
    header: "EF Start Date",
    Cell: ({ cell }: any) =>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ ml: 1 }} component="span">
          {getFormattedDate(cell.getValue())}
        </Box>
      </Box>
  },
  {
    accessorKey: "endDate",
    header: "EF End Date",
    Cell: ({ cell }: any) =>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ ml: 1 }} component="span">
          {getFormattedDate(cell.getValue())}
        </Box>
      </Box>
  }
];

export const SELECT_FIELDS = [
  "providerName",
  "utilityType"
];

export const DATE_FIELDS = [
  "startDate",
  "endDate",
];
